// extracted by mini-css-extract-plugin
export default {"base":"HorizontalBarChartDisplay_base__vKkvJ","select":"HorizontalBarChartDisplay_select__7qbsf"};